import { useVisitorPrices, withPrice } from './prices'

// Shared by every page whose CTA sells Jumpstart, so the wording cannot drift.
export const jumpstartModal = (price) => ({
  eyebrow: withPrice('JUMPSTART', price, ' · '),
  title: 'Start your Jumpstart',
  intro:
    'Just the details we need to set up your account and take the payment. Your first challenge is matched to you inside the portal, in the assessment you do on day one.',
  // experience and stage are asked in the portal's day-one assessment instead
  askProfile: false,
  // creates the account, so continuing accepts the Terms of Use
  collectAccountFields: true,
  submitLabel: withPrice('Continue to Jumpstart', price),
  successTitle: "You're in.",
  // Passwordless purchase goes straight to checkout, so no "check your email" copy.
  successBody: `Your account is ready. Taking you to secure checkout to complete your ${withPrice(
    'Jumpstart enrolment',
    price && `(${price})`,
    ' ',
  )}.`,
})

export const useJumpstartModal = () => jumpstartModal(useVisitorPrices().jumpstart)
